// src/pages/attendance/styles/attendanceStyles.js

export const getAttendanceStyles = (currentTheme, isDarkMode, language) => {
    const c = currentTheme.colors;
    const f = currentTheme.fonts;
    const dir = language === "ar" ? "rtl" : "ltr";
    // Phone layout (≤768px) — the styles are rebuilt on every render.
    const isPhone = typeof window !== "undefined" && window.innerWidth <= 768;

    return {
        container: { marginTop: 2, direction: dir },

        backgroundDecorative: { ...currentTheme.background.decorative.container },

        contentWrapper: { position: "relative", zIndex: 2, padding: "0", marginTop: "-25px" },

        timeTracker: {
            border: `1px solid ${c.border}`,
            borderRadius: "24px",
            padding: "40px",
            textAlign: "center",
            marginBottom: "32px",
            position: "relative",
            overflow: "hidden",
        },
        card1: ({ screenSize, isRTL }) => ({
            background: isDarkMode ? "rgba(255,255,255,0.02)" : "rgba(255,255,255,0.9)",
            WebkitBackdropFilter: isDarkMode ? "blur(25px) saturate(180%)" : "blur(10px)",
            border: isDarkMode ? "1px solid rgba(255,255,255,0.15)" : "1px solid rgba(0,0,0,0.05)",
            borderRadius: screenSize.isMobile ? "12px" : screenSize.isTablet ? "20px" : "28px",
            padding: screenSize.isMobile ? "16px" : screenSize.isTablet ? "20px" : "28px",
            boxShadow: "none",
            marginBottom: screenSize.isMobile ? "16px" : screenSize.isTablet ? "20px" : "24px",
            transition: "all 0.3s ease",
            cursor: "pointer",
            direction: isRTL ? "rtl" : "ltr",
        }),

        timeTrackerDecoration: {
            position: "absolute", top: "-50px", right: "-50px",
            width: "150px", height: "150px",
            background: isDarkMode ? "rgba(255,255,255,0.05)" : "rgba(59,130,246,0.08)",
            borderRadius: "50%", filter: "blur(40px)",
        },

        clockDisplay: {
            fontSize: isPhone ? "40px" : "56px", fontWeight: "700", marginBottom: isPhone ? "10px" : "16px",
            whiteSpace: "nowrap", fontVariantNumeric: "tabular-nums",
            fontFamily: "'Cairo', system-ui, monospace", color: c.textPrimary,
            textShadow: "none",
        },

        dateDisplay: {
            fontSize: "18px", marginBottom: "32px", opacity: 0.9,
            color: c.textSecondary, fontWeight: "500", fontFamily: "'Cairo', sans-serif",
        },

        buttonContainer: {
            display: "flex", justifyContent: "center",
            gap: "20px", marginBottom: "32px", flexWrap: "wrap",
        },

        statsGrid: {
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(min(150px, 100%), 1fr))",
            gap: "24px", marginBottom: "32px",
        },

        loadingContainer: {
            display: "flex", justifyContent: "center", alignItems: "center",
            padding: "40px", color: c.textSecondary, fontFamily: "'Cairo', sans-serif",
        },

        spinner: {
            display: "inline-block", width: "40px", height: "40px",
            border: `4px solid ${c.borderLight}`,
            borderTopColor: c.primary, borderRadius: "50%",
            animation: "spin 1s linear infinite", marginBottom: "12px",
        },

        // location error block
        locationError: {
            padding: "24px",
            background: isDarkMode
                ? "linear-gradient(135deg, rgba(239,68,68,0.1), rgba(220,38,38,0.05))"
                : "linear-gradient(135deg, rgba(254,226,226,0.8), rgba(254,242,242,0.6))",
            borderRadius: "16px", marginTop: "20px",
            border: `2px solid ${isDarkMode ? "rgba(239,68,68,0.3)" : "rgba(239,68,68,0.2)"}`,
            position: "relative", overflow: "hidden",
        },

        // weekly
        weeklyGrid: {
            display: "grid",
            gridTemplateColumns: isPhone ? "repeat(2, minmax(0, 1fr))" : "repeat(auto-fit, minmax(200px, 1fr))",
            gap: isPhone ? "10px" : "20px", marginTop: isPhone ? "16px" : "24px",
        },

        dayCard: (status, colors) => {
            const statusBorderColor =
                status === "present"  ? "#087e2a"
                : status === "late"   ? "#b26a00"
                : status === "absent" ? "#d7263d"
                : status === "rest_day" || status === "Rest Day" ? "#3730a3"
                : status === "holiday"  ? "#c026d3"
                : status === "On Leave" || status === "leave" || status === "onLeave" ? "#512da8"
                : status === "half_day" ? "#b45309"
                : colors.borderLight;

            return ({
            background: colors.cardBackground,
            border: `2px solid ${statusBorderColor}`,
            borderRadius: isPhone ? "14px" : "20px", padding: isPhone ? "14px 12px" : "24px", textAlign: "center",
            transition: "all 0.3s cubic-bezier(0.4,0,0.2,1)", minHeight: isPhone ? "0" : "180px",
            display: "flex", flexDirection: "column", justifyContent: "space-between",
            position: "relative", overflow: "hidden",
            boxShadow: "none",
        });},

        dayHeader: { display: "flex", flexDirection: "column", alignItems: "center", gap: "12px", marginBottom: "20px" },
        dayName: { fontSize: f.sizes.lg, fontWeight: f.weights.bold, color: c.textPrimary, marginBottom: "8px", fontFamily: "'Cairo', sans-serif" },
        timeDetails: { fontSize: f.sizes.sm, color: c.textSecondary, lineHeight: "1.6", fontFamily: "'Cairo', sans-serif" },
        timeRow: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" },
        timeLabel: { color: c.textMuted, fontFamily: "'Cairo', sans-serif" },
        timeValue: { fontWeight: f.weights.semibold, color: c.textPrimary, fontFamily: "'Cairo', sans-serif" },
        hoursDisplay: {
            marginTop: "12px", padding: "8px 16px",
            background: `${c.primary}15`, borderRadius: "12px",
            fontSize: f.sizes.sm, fontWeight: f.weights.bold, color: c.primary,
            textAlign: "center", fontFamily: "'Cairo', sans-serif",
        },

        weeklySummary: {
            marginTop: "40px", padding: "24px",
            background: isDarkMode ? "rgba(59,130,246,0.08)" : "rgba(255,255,255,0.9)",
            borderRadius: "20px", border: `1px solid ${c.borderLight}`,
            boxShadow: "none",
        },
        summaryTitle: {
            margin: "0 0 20px 0", color: c.textPrimary, fontSize: f.sizes.lg,
            fontWeight: f.weights.semibold, display: "flex", alignItems: "center", gap: "12px",
            fontFamily: "'Cairo', sans-serif",
        },
        summaryGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: "24px" },
        summaryItem: { textAlign: "center" },
        summaryValue: (color) => ({ fontSize: "32px", fontWeight: f.weights.bold, color, marginBottom: "8px", fontFamily: "'Cairo', sans-serif" }),
        summaryLabel: { fontSize: f.sizes.sm, color: c.textSecondary, fontWeight: f.weights.medium, fontFamily: "'Cairo', sans-serif" },

        // tables
        tableContainer: {
            overflowX: "auto", borderRadius: "16px",
            border: `1px solid ${c.borderLight}`, background: c.cardBackground,
            boxShadow: "none",
        },
        table: { width: "100%", borderCollapse: "collapse", fontFamily: "'Cairo', sans-serif" },
        tableHeader: {
            background: isDarkMode
                ? "linear-gradient(135deg,rgba(59,130,246,0.1),rgba(99,102,241,0.05))"
                : "linear-gradient(135deg,rgba(248,250,252,0.8),rgba(241,245,249,0.6))",
            color: c.textPrimary, padding: "20px 16px",
            textAlign: language === "ar" ? "right" : "left",
            fontSize: f.sizes.sm, fontWeight: f.weights.semibold,
            borderBottom: `2px solid ${c.border}`, fontFamily: "'Cairo', sans-serif",
        },
        tableCell: {
            padding: "16px", borderBottom: `1px solid ${c.borderLight}`,
            color: c.textPrimary, fontSize: f.sizes.sm,
            textAlign: language === "ar" ? "right" : "left", fontFamily: "'Cairo', sans-serif",
        },
        tableRow: { transition: "all 0.2s ease" },

        statusIndicator: (status, colors) => ({
            display: "inline-flex", alignItems: "center", gap: "8px",
            padding: "8px 16px", borderRadius: "20px",
            fontSize: f.sizes.xs, fontWeight: f.weights.semibold,
            background: `${getStatusColor(status, colors)}15`,
            color: getStatusColor(status, colors),
            border: `1px solid ${getStatusColor(status, colors)}30`,
            fontFamily: "'Cairo', sans-serif",
        }),

        // metrics
        metricsGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "24px" },
        metricCard: {
            padding: "24px", background: c.cardBackground, borderRadius: "20px",
            border: `1px solid ${c.borderLight}`,
            boxShadow: "none",
        },
        metricHeader: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" },
        metricTitle: { color: c.textPrimary, fontSize: f.sizes.base, fontWeight: f.weights.semibold, margin: 0, fontFamily: "'Cairo', sans-serif" },
        metricValue: (color) => ({ color, fontSize: f.sizes.xl, fontWeight: f.weights.bold, fontFamily: "'Cairo', sans-serif" }),
        metricFooter: { display: "flex", justifyContent: "space-between", marginTop: "12px", fontSize: f.sizes.xs, color: c.textMuted, fontFamily: "'Cairo', sans-serif" },
    };
};

// helper مستخدمة جوه الستايل بس
const getStatusColor = (status, colors) => {
    switch (status) {
        case "present": return colors.success;
        case "late": return colors.warning;
        case "absent": return colors.danger;
        default: return colors.textMuted;
    }
};

// ==================== STATUS BADGE STYLING (from Attendance.js) ====================
export const getStatusBadgeStyle = (status) => {
    const baseStyle = {
        padding: "4px 12px",
        borderRadius: "20px",
        fontSize: "12px",
        fontWeight: "600",
        textAlign: "center",
        display: "inline-block",
    };

    switch (status) {
        case "present":
            return { ...baseStyle, background: "#b9fbc0", color: "#087e2a" }; // fresh green
        case "absent":
            return { ...baseStyle, background: "#ffd6d6", color: "#d7263d" }; // modern red
        case "late":
            return { ...baseStyle, background: "#fff2cc", color: "#b26a00" }; // gold yellow
        case "rest_day":
        case "Rest Day":
            return { ...baseStyle, background: "#e0e7ff", color: "#3730a3" }; // soft blue
        case "holiday":
            return { ...baseStyle, background: "#ffe0f0", color: "#c026d3" }; // pink
        case "On Leave":
        case "leave":
        case "onLeave":
            return { ...baseStyle, background: "#d1c4e9", color: "#512da8" }; // lavender purple
        case "half_day":
            return { ...baseStyle, background: "#ffe4b5", color: "#b45309" }; // light orange
        default:
            return { ...baseStyle, background: "#e0e7ef", color: "#334155" };
    }
};